import React from 'react';
import './Footer.scss';

const Footer = () => (
  <footer>
    <div className='container'>
      ® Tumenuonline 2019 - Todos los derechos reservados. 
    </div>
  </footer>
);

export default Footer;